import * as $ from 'jquery';
import 'bootstrap';
import 'daterangepicker/daterangepicker.js';
import moment from 'moment';

export default (function () {

  let $formContainer = $('.applicants-search-form');

  if (0 < $formContainer.length) {

    let $from = $formContainer.find('input[name=fromDate]');
    let $to = $formContainer.find('input[name=toDate]');

    let options = {'cancelButtonClasses': 'cancel'}

    if ($from.length && $to.length) {
      if ($from.val().length && $to.val().length > 0) {
        options.startDate = moment.unix($from.val());
        options.endDate = moment.unix($to.val());
        $('#applicantsrange').text(moment.unix($from.val()).format('M/D/YY') + ' - ' + moment.unix($to.val()).format('M/D/YY'));
      }

      $('#applicantsrange').daterangepicker(options, function (from, to) {
        $from.val(from.unix());
        $to.val(to.unix());
        $('#applicantsrange').text(from.format('M/D/YY') + ' - ' + to.format('M/D/YY'));
      });
    }
    
    $('.reset-transaction-btn').click(async function (e) {
      e.preventDefault();

      $('#reset-transaction-modal').modal('show');
      
      const confirmed = await new Promise((res) => {
        $('#reset-modal-btn-ok').one('click', () => res(true))
        $('#reset-transaction-modal').one('hide.bs.modal', () => res(false));
      });
      
      if (confirmed) {
        $(this).unbind('click').click();
      }
    });
  }


}());